// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"usergroup"},"children":[{"tag":"g","attrs":{"id":"fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M16 8C16 10.2091 14.2091 12 12 12C9.79086 12 8 10.2091 8 8C8 5.79086 9.79086 4 12 4C14.2091 4 16 5.79086 16 8Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M5 19C5 16.7909 6.79086 15 9 15H15C17.2091 15 19 16.7909 19 19V21H5V19Z"}}]},{"tag":"g","attrs":{"id":"stroke1"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M16 8C16 10.2091 14.2091 12 12 12C9.79086 12 8 10.2091 8 8C8 5.79086 9.79086 4 12 4C14.2091 4 16 5.79086 16 8Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M5 19C5 16.7909 6.79086 15 9 15H15C17.2091 15 19 16.7909 19 19V21H5V19Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M7 4C4.79086 4 3 5.79086 3 8C3 10.2091 4.79086 12 7 12C3.68629 12 1 14.6863 1 18V21M23 21V18C23 14.6863 20.3137 12 17 12C19.2091 12 21 10.2091 21 8C21 5.79086 19.2091 4 17 4","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const UsergroupIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'usergroup',
    ref,
    icon: element,
  },
));

UsergroupIcon.displayName = 'UsergroupIcon';

export default UsergroupIcon;
